<h2 class="dsd-t-6 titre">{{ 'caad.modifier-fiserv.titreBlocContact' | translate }}</h2>
<p>{{ 'caad.modifier-fiserv.descriptionBlocContact' | translate }}</p>
<a class="lien-bloc-contact" [href]="numeroTelephone">{{ 'caad.modifier-fiserv.lienTexteBlocContact' | translate }}</a>
